module.exports = __webpack_public_path__ + "static/media/kpop.c279d1e6.jpg";